import SlickCarousel from './SlickCarousel/index';

export default function CarouselBanners({ isFeatured = false, data, itemsPerPage = 4 }) {
  return (
    <div className='container mb-8 md:mb-12'>
      <h3
        className={`text-gray-600 md:mb-3 font-medium ${
          isFeatured
            ? 'md:text-center text-2xl md:text-4xl font-bold feauteredOffers-title mb-0 md:mb-4'
            : 'feauteredSevenTwenty-title'
        }`}
      >
        {data.categoria.descripcion}
      </h3>
      <SlickCarousel itemsPerPage={itemsPerPage} data={data} />
    </div>
  );
}
